import * as PIXI from "pixi.js"
import TWEEN from "@tweenjs/tween.js"
import R from "../../config/R"
import Button from "../../objects/Button"
import * as Events from "../../Events"
import {CustomMultiStyleText} from "../../objects/CustomMultiStyleText"

export default class QuestionBox extends PIXI.Container {
  constructor(x, y, questions, resources, level) {
    super()

    this.x = x
    this.y = y

    this.questionIndex = 0;
    this.questions = questions

    this.fontColor = ""

    switch(level){
      case "level1" :
        this.fontColor = '#000'
        this.questionBox1 = new Button(0, 0, resources[R.images.level1Choice1.name].texture, false)
        this.questionBox2 = new Button(0, 0, resources[R.images.level1Choice2.name].texture, false)
        break
      case "level2" :
        this.fontColor = '#006ebf'
        this.questionBox1 = new Button(0, 0, resources[R.images.level2Choice1.name].texture, false)
        this.questionBox2 = new Button(0, 0, resources[R.images.level2Choice2.name].texture, false)
        break
      case "level3" :
        this.fontColor = '#006ebf'
        this.questionBox1 = new Button(0, 0, resources[R.images.level3Choice1.name].texture, false)
        this.questionBox2 = new Button(0, 0, resources[R.images.level3Choice2.name].texture, false)
        break
    }

    // console.log("fontColor", this.fontColor)

    const wordStyle = new PIXI.TextStyle({
      ...R.textStyles.chinese(70),
      wordWrap: true,
      wordWrapWidth: 500,
      breakWords: true,
      fill:  this.fontColor,
    })
    const yiStyle = new PIXI.TextStyle({
      ...R.textStyles.chinese(55),
      wordWrap: true,
      wordWrapWidth: 500,
      breakWords: true,
      fill:  this.fontColor
    })


    this.choice1 = new CustomMultiStyleText('',
      {
        "default":{
          ...wordStyle,
          stroke: '#fff',
          fill: this.fontColor,
          dropShadowColor: '#ffffff',
          dropShadow: true,
          dropShadowBlur: 20,
          dropShadowAngle: 0,
          dropShadowDistance: 0,
          strokeThickness: 10,
          lineJoin : 'round',
          lineSpace: 1.2,
          trim: true
        },
        "yi":{
          ...yiStyle,
        },
      }
    )
    this.choice1.anchor.x = 0.5
    this.choice1.anchor.y = 0.5

    this.choice2 = new CustomMultiStyleText('',
      {
        "default":{
          ...wordStyle,
          stroke: '#fff',
          fill: this.fontColor,
          dropShadowColor: '#ffffff',
          dropShadow: true,
          dropShadowBlur: 20,
          dropShadowAngle: 0,
          dropShadowDistance: 0,
          strokeThickness: 10,
          lineJoin : 'round',
          lineSpace: 1.2,
          trim: true
        },
        "yi":{
          ...yiStyle,
          fill: this.fontColor,
        }
      }
    )
    this.choice2.anchor.x = 0.5
    this.choice2.anchor.y = 0.5

    this.answer = ''

    const container1 = new PIXI.Container()
    const container2 = new PIXI.Container()

    this.questionBox1.addOnClickListener(() => {
      Events.hub.publishEvent(Events.ANSWERED, { choice: this.choice1.text, answer : this.answer  })
    })

    this.questionBox2.addOnClickListener(() => {
      Events.hub.publishEvent(Events.ANSWERED, { choice: this.choice2.text, answer : this.answer })
    })

    this.invisible()

    container1.addChild(this.questionBox1)
    container1.addChild(this.choice1)

    container2.addChild(this.questionBox2)
    container2.addChild(this.choice2)

    container1.x = 0
    container1.y = 500

    container2.x = 800
    container2.y = 500

    this.addChild(container1)
    this.addChild(container2)

    this.nextQuestion()
  }

  nextQuestion(){
    console.log('questionIndex:' + this.questionIndex)
    const question = this.questions[this.questionIndex]

    // works as long as not more than 2 line
    const exptecedWrappedText1 = this.choice1.wordWrap(question.choice1)
    if(exptecedWrappedText1.endsWith("\n。") || exptecedWrappedText1.endsWith("\n！")){
      this.choice1._style.wordWrap = false
      this.choice1._style.breakWords = false
    }
    else {
      this.choice1._style.wordWrap = true
      this.choice1._style.breakWords = true
    }

    // works as long as not more than 2 line
    const exptecedWrappedText2 = this.choice2.wordWrap(question.choice2)
    if(exptecedWrappedText2.endsWith("\n。") || exptecedWrappedText2.endsWith("\n！")){
      this.choice2._style.wordWrap = false
      this.choice2._style.breakWords = false
    }
    else {
      this.choice2._style.wordWrap = true
      this.choice2._style.breakWords = true
    }

    this.choice1.text = question.choice1
    this.choice2.text = question.choice2
    this.answer = question.answer

    this.questionIndex = this.questionIndex + 1
  }

  textWithoutMarkUp(multilineText, str){
    let result = ''
    const tags = Object.keys(multilineText.textStyles).join("|")
    const re = new RegExp("(</?(" + tags + ")>)", "g")
    const parts = str.split(re)
    for (let k = 0; k < parts.length; k++) {
      if (re.test(parts[k])) {
        if (parts[k][1] === "/") {
          k++;
        }
        else {
          k++;
        }
      }
      else {
        result += parts[k]
      }
    }
    return result
  }

  isLastQuestion(){
    // disable the onclick question box 1 and box 2 when it is a last question
    if (this.questionIndex >= this.questions.length){
      this.questionBox1.removeOnClickListener()
      this.questionBox2.removeOnClickListener()
    }
    return this.questionIndex >= this.questions.length
  }

  invisible(){
    this.alpha = 0;
    this.questionBox1.interactive = false;
    this.questionBox2.interactive = false;
  }

  disableQuestionBox(opt = {}){
    this.questionBox1.interactive = false;
    this.questionBox2.interactive = false;

    if(!opt.isVisible){
      this._tween = new TWEEN.Tween(this)
        .to({alpha: 0}, 1000)
        //.easing(this.createNoisyEasing(0.3,TWEEN.Easing.Quartic.In))
        .easing(TWEEN.Easing.Linear.None)
        .onComplete(() => {
          if(!this.isLastQuestion())
            this.nextQuestion()
        })
        .start()
    }

  }

  enableQuestionBox(){
    this.visible = true;
    this.questionBox1.interactive = true;
    this.questionBox2.interactive = true;

    this._tween = new TWEEN.Tween(this)
      .to({alpha: 1}, 1000)
      //.easing(this.createNoisyEasing(0.3,TWEEN.Easing.Quartic.In))
      .easing(TWEEN.Easing.Linear.None)
      .onComplete(() => {
      })
      .start()
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/common/QuestionBox.js